// extracted by mini-css-extract-plugin
var _1 = "PropsPassedMessageStyle-module__box--description___qrb1g";
var _2 = "PropsPassedMessageStyle-module__box--title___p1T2l";
var _3 = "PropsPassedMessageStyle-module__box-links-wrapper___hano7";
var _4 = "PropsPassedMessageStyle-module__box--description___qrb1g";
var _5 = "PropsPassedMessageStyle-module__box-links-wrapper___hano7";
var _6 = "PropsPassedMessageStyle-module__box--title___p1T2l";
export { _1 as "box--description", _2 as "box--title", _3 as "box-links-wrapper", _4 as "boxDescription", _5 as "boxLinksWrapper", _6 as "boxTitle" }
